import { useContext, useEffect, useState } from 'react'
import { ModalContext } from '@nv/contexts'
import { CheckAnimationIcon } from '@nv/images/design/check-animation-icon'
import MemberIcon from '@nv/images/design/member-icon'
import { XCircleAnimatedIcon } from '@nv/images/design/x-circle-animated-icon'
import { AdminVoterAuthService } from '@nv/services'
import { useTranslation } from 'react-i18next'
import styles from './ConfirmUnlockAdmin.module.scss'

export const ConfirmUnlockAdmin = ({ selectedUser, fetchUsers, voter = false }) => {
  const { t } = useTranslation()
  const { setHeaderLabel, setBtns, onClose } = useContext(ModalContext)
  const [status, setStatus] = useState('idle')
  const [loading, setLoading] = useState(false)
  const name = !voter ? selectedUser?.username : selectedUser.fullName

  const handleOnClose = () => {
    if (voter) {
      onClose()
      fetchUsers()
    } else {
      onClose()
    }
  }

  const callConfirm = async () => {
    if (!selectedUser || loading) return
    setLoading(true)

    try {
      let resp
      if (voter) {
        resp = await AdminVoterAuthService.adminUnlockAccountForUser(selectedUser.keycloakId)
      } else {
        resp = await AdminVoterAuthService.adminUnlockAccountFoAdminUser(selectedUser.id)
      }
      setStatus(resp.success ? 'success' : 'error')
    } catch {
      setStatus('error')
    }
    setLoading(false)
    if (!voter) {
      fetchUsers()
    }
  }

  useEffect(() => {
    setHeaderLabel(t('admin.adminUsers.ConfirmUnlockAdminAccount'))
    setBtns([
      ...(status === 'idle' ? [{ text: t('buttons.cancel'), onClick: onClose, variant: 'secondary', disabled: loading }] : []),
      {
        text: status !== 'idle' ? t('buttons.ok') : t('buttons.unlock'),
        onClick: status !== 'idle' ? handleOnClose : callConfirm,
        disabled: loading,
      },
    ])
  }, [status, loading])

  return (
    <div className={styles['container']}>
      {status === 'idle' ? (
        <>
          <MemberIcon />
          <span>{t('admin.adminUsers.ConfirmUnlockAdmin', { name: name })}</span>
        </>
      ) : status === 'success' ? (
        <>
          <CheckAnimationIcon />
          <span>{t('admin.adminUsers.successUnlockUser', { name: name })}</span>
        </>
      ) : (
        <>
          <XCircleAnimatedIcon />
          <span>{t('admin.adminUsers.errorUnlockUser', { name: name })}</span>
        </>
      )}
    </div>
  )
}
